import Vue from "vue";
import * as sites from "../api/sites";

export default {
  state: {
    site: {},
    sites: [],
    siteTypes: [],
    siteLogs: {},
    siteType: {}
  },
  getters: {
    getSiteLogs: state => index => state.siteLogs[index]
  },
  mutations: {
    getSite(state, site) {
      state.site = site;
    },
    getSites(state, sites) {
      state.sites = sites;
    },
    getSiteTypes(state, siteTypes) {
      state.siteTypes = siteTypes;
    },
    getSiteLogs(state, { id, logs }) {
      Vue.set(state.siteLogs, `site-${id}`, logs);
    },
    getSiteInType(state, siteType) {
      state.siteType = siteType;
    }
  },
  actions: {
    async getSite({ commit }, { id }) {
      commit("getSite", await sites.getSite(id));
    },
    async getSites({ commit, dispatch }) {
      const data = await sites.getSites();
      data.map(site => dispatch("getSiteLogs", { id: site.id }));
      commit("getSites", data);
    },
    async getSiteInType({ commit }, id) {
      const data = await sites.getSiteInType(id);
      commit("getSiteInType", data);
    },
    // FIXME: To move in siteTypes module
    async getSiteTypes({ commit }) {
      const data = await sites.getSiteTypes();
      commit("getSiteTypes", data);
    },
    async createSite({ dispatch }, site) {
      try {
        const response = await sites.createSite(site);
        dispatch("getSites");
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            break;
          default:
            dispatch("setToastMessage", { message: `An error occured !` });
            break;
        }
        dispatch("setToastMode", { mode: "error" });
        dispatch("setOpenToast", { opened: true });
      }
    },
    async updateSite({ dispatch }, { id, site }) {
      const response = await sites.updateSite(id, site);
      dispatch("getSites");
      dispatch("getSite", { id });
      return response;
    },
    async deleteSite({ dispatch }, { id }) {
      try {
        const response = await sites.deleteSite(id);
        dispatch("getSites");
        return response;
      } catch (error) {
        error;
      }
    },
    async addUserToSite({ dispatch }, { id, email }) {
      const response = await sites.addUser(id, email);
      dispatch("getSites");
      dispatch("getSite", { id });
      return response;
    },
    async removeUserFromSite({ dispatch }, { id, email }) {
      const response = await sites.removeUser(id, email);
      dispatch("getSites");
      dispatch("getSite", { id });
      return response;
    },
    async getSiteLogs({ commit }, { id, scale, time }) {
      if (!scale) scale = "day";
      if (!time) time = 2;
      commit("getSiteLogs", { id, logs: await sites.getLogs(id, scale, time) });
    },
    async addEndpoint({ dispatch }, { url, integrityKey, siteId }) {
      const response = await sites.addEndpoint(url, integrityKey, siteId);
      if (response.id) dispatch("getSite", { id: siteId });
      return response;
    },
    async updateEndpoint({ dispatch }, { id, url, integrityKey, siteId }) {
      const response = await sites.updateEndpoint(
        id,
        url,
        integrityKey,
        siteId
      );
      if (response.id) dispatch("getSite", { id: siteId });
      return response;
    },
    async removeEndpoint({ dispatch }, { id, siteId }) {
      const response = await sites.removeEndpoint(id);
      if (response.success) dispatch("getSite", { id: siteId });
      return response;
    }
  }
};
